import { useEffect, useState, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { Typography, Modal, Empty, Button, Tag, Card, Avatar, message} from "antd";
import { MailOutlined, CopyOutlined } from "@ant-design/icons";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";
import { LinkedinOutlined, MediumOutlined} from '@ant-design/icons';
import {Footer, Container, MenuSmall} from '../auxiliary/auxiliary';


const EmailActions = ({ email }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const copyEmail = () => {
    navigator.clipboard.writeText(email);

    messageApi.open({
      type: 'success',
      content: 'Email copied to clipboard',
    });
  };

  return (
    <Button.Group>
       {contextHolder}
      <Button
        type="primary"
        icon={<MailOutlined />}
        href={`mailto:${email}`}
      >
        Send Report
      </Button>
      <Button
        icon={<CopyOutlined />}
        onClick={copyEmail}
      />
    </Button.Group>
  );
};



function ProfileCard({ profile }) {


  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    window.open(profile.url, "_blank", "noopener,noreferrer");
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  return (



  
  <div style={{ marginTop: "10px" }}>

  <Modal
        title="Go to External Site"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>You are about to leave the current site and go to an external resource:</p>
        <p><strong>{profile.url}</strong></p>
        <p>Do you want to continue?</p>
      </Modal>


    <div style={{display: "grid",
    gridTemplateColumns: "100px 2fr",
    gridTemplateRows: "repeat(3, 1fr)", 
    gap: "14px"}}>
      <div style={{ gridRow: "span 2 / span 2"}}>
      <Avatar
          shape="square"
          size={50}  
          src={"/logo/"+profile.logo}
          style={{width:"100%", height:"100%"}}
          
          /></div>
      <div style={{}}> <Typography.Title  level={2} style={{ margin: 0 }}> {profile.name} </Typography.Title></div>
      <div style={{gridColumnStart: 2}}> {/* Теги */}
             <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", marginTop: "4px" }}>
             {profile.tags.map(tag => {
                 let color = tag.length > 5 ? 'geekblue' : 'green';
                 if (tag === 'loser') {
                   color = 'volcano';
                 }
                 return (
                   <Tag color={color} key={tag}>
                     {tag.toUpperCase()}
                   </Tag>
                 );
               })}
               </div>
           </div>
      <div style={{ gridColumn: "span 2 / span 2", gridRowStart: 3}}> {profile?.email === null ? ( <Button type="primary" onClick={showModal} ghost>Original Bug Bounty page</Button>):(<EmailActions email={profile.email }/>)}</div>
    
    </div>
  </div>
    
  );
}





function BugbountyCard(props) {

const program = props.data[props.programId-1];
const [data, setData] = useState(); 
const didSetMenu = useRef(false);


useEffect(() => {
  if (!program || didSetMenu.current) return;
  async function fetchData() {
      try {
        const response = await fetch(`/api/bugbounty/${program.key}/main.md`); 
        if (!response.ok) throw new Error("Network response was not ok");
        const text = await response.text();
        setData(text);
      } catch (err) {
        console.error(err);
      } finally {
       // setLoading(false);
      }
    }

  
    fetchData();

    props.setMenuItem(prev => [
      ...prev,
      { title: program.name }
    ]);

  didSetMenu.current = true; // пометили, что уже добавили
}, [program]);


  return (    
  <div>
      { data && program ?(
        <Card title={<ProfileCard profile={program}/>} variant="borderless" >
          
          <ReactMarkdown
            remarkPlugins={[[remarkGfm, { singleTilde: true }]]}
            components={{
              table: ({ node, ...props }) => (
                <table
                  {...props}
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "16px",
                  }}
                />
              ),
              th: ({ node, ...props }) => (
                <th
                  {...props}
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    backgroundColor: "#f5f5f5",
                    textAlign: "left",
                  }}
                />
              ),
              td: ({ node, ...props }) => (
                <td
                  {...props}
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px",
                    textAlign: "left",
                  }}
                />
              ),
              tr: ({ node, ...props }) => (
                <tr
                  {...props}
                  style={{
                    // hover эффект
                    transition: "background-color 0.2s",
                  }}
                />
              ),
            }}>
            {data}
          </ReactMarkdown>
        </Card>
        
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
       
     
     
  </div>
  );
}


export default BugbountyCard;